export default __webpack_public_path__ + "static/media/illustration-intro.85cce7ce.svg";